/*
 * Author: Dw
 * File Created: Tuesday, 25-05-20 10:19 am
 * Last Modified: Thursday, 25-06-05 11:22 am, by Dw
 */

import { useMemo } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import { Box, Button } from '@mui/material';
import { Icon } from '@ucard/ds/Icon';
import type { DrawerDialogProps } from '@ucard/ds/message';
import { BaseDialog, BaseDialogProps } from '@ucard/ds/message';
import { updateReminderStatus } from '../../../services/marketing.service';
import { useMarketingStore } from '../../../stores/useMarketingStore';
interface AccountMgntFeeProps extends DrawerDialogProps {
  onClose?: () => void;
}
const AccountMgntFee = (props: AccountMgntFeeProps) => {
  const {
    t
  } = useTranslation('common');
  const {
    accountManagementFee
  } = useMarketingStore();
  const {
    targetAchievedReminderShown,
    consumptionReminderShown,
    needRemindRemainingConsumptionAmount,
    additionalInfo,
    remainingConsumptionAmountCurrencyCode,
    targetAchieved,
    isValidPeriod,
    cumulativeConsumptionAmount
  } = accountManagementFee ?? {};
  const dialogType = useMemo(() => {
    if (consumptionReminderShown === 0 && isValidPeriod === 1 && targetAchieved === 0) {
      return 'reminder';
    }
    if (needRemindRemainingConsumptionAmount === 1 && isValidPeriod === 1) {
      return 'continue';
    }
    if (targetAchievedReminderShown === 0 && targetAchieved === 1) {
      return 'complete';
    }
  }, [targetAchievedReminderShown, targetAchieved, consumptionReminderShown, isValidPeriod, needRemindRemainingConsumptionAmount]);
  const submit = async () => {
    const params = {
      complete: {
        targetAchievedReminderShown: 1
      },
      reminder: {
        consumptionReminderShown: 1
      },
      continue: undefined
    };
    if (dialogType && params[dialogType]) {
      await updateReminderStatus(params[dialogType]);
    }
    props.onClose?.();
  };
  if (!dialogType) {
    return null;
  }
  return <BaseDialog PaperProps={{
    sx: {
      width: ['100%'],
      maxWidth: ['100%', '300px'],
      backgroundColor: '#232530',
      backgroundImage: 'url("https://static.thedecard.com/images/dvault/fee/dialog-bg.svg")',
      border: '1px solid #A993FF',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      padding: '50px 20px 28px',
      overflow: 'visible'
    }
  }} showClose={false} {...props} data-sentry-element="BaseDialog" data-sentry-component="AccountMgntFee" data-sentry-source-file="index.tsx">
      <Box sx={{
      position: 'absolute',
      top: '-27px',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '150px',
      height: '120px',
      backgroundImage: `url("${additionalInfo?.icon}")`,
      backgroundSize: 'cover'
    }} data-sentry-element="Box" data-sentry-source-file="index.tsx" />

      <Box alignItems="center" display="flex" flexDirection="column" gap="12px" data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <h3 style={{
        fontSize: '18px',
        margin: 0
      }}>
          <Trans components={{
          1: <span style={{
            color: '#EBCBA0',
            fontWeight: 600
          }} />
        }} i18nKey={`fee-mgnt.${dialogType}.title`} ns="common" values={{
          days: additionalInfo?.daysThreshold,
          spend: additionalInfo?.consumptionThreshold,
          fee: additionalInfo?.rewardAmount,
          currency: remainingConsumptionAmountCurrencyCode
        }} data-sentry-element="Trans" data-sentry-source-file="index.tsx" />
        </h3>
        <p style={{
        fontSize: '14px',
        margin: 0,
        textAlign: 'center'
      }}>
          <Trans components={{
          1: <span style={{
            color: '#EBCBA0',
            fontWeight: 600
          }} />
        }} i18nKey={`fee-mgnt.${dialogType}.desc`} ns="common" values={{
          days: additionalInfo?.daysThreshold,
          spend: additionalInfo?.consumptionThreshold,
          fee: additionalInfo?.rewardAmount,
          currency: remainingConsumptionAmountCurrencyCode,
          alreadySpent: cumulativeConsumptionAmount
        }} data-sentry-element="Trans" data-sentry-source-file="index.tsx" />
        </p>
        <Button fullWidth onClick={submit} sx={{
        marginTop: '12px'
      }} data-sentry-element="Button" data-sentry-source-file="index.tsx">
          {t('fee-mgnt.ok')}
        </Button>
      </Box>
      <Box onClick={submit} sx={{
      position: 'absolute',
      top: 'calc(100% + 40px)',
      left: '50%',
      transform: 'translate(-50%, 0)',
      borderRadius: '50%',
      border: '1px solid #9EA8B6',
      width: '28px',
      height: '28px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Icon name="Close" sx={{
        color: '#9EA8B6',
        fontSize: '18px'
      }} data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
      </Box>
    </BaseDialog>;
};
export default AccountMgntFee;